/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: false, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "",
  title: "Ben Chapman",
  subTitle:
    "I am a Computer Science student at the University of Cambridge. I've interned in Milan as a Software Engineer at Bending Spoons and, next summer, I'll be interning at Jane Street. I've also enjoyed competing in a variety of competitions during my time at uni.",
  resumeLink: "/BenChapmanCV.pdf", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/Selucus",
  linkedin: "https://www.linkedin.com/in/ben-chapman-bjc/",

  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications"
    ),
    emoji("⚡ Progressive Web Applications ( PWA ) in normal and SPA Stacks"),
    emoji(
      "⚡ Integration of third party services such as Firebase/ AWS / Digital Ocean"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "swift",
      fontAwesomeClassname: "fab fa-swift"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer Intern",
      company: "Jane Street",
      companylogo: require("./assets/images/jane_street.png"),
      date: "Summer 2026",
      desc: "Excited to intern in London at Jane Street next summer",
      footerLink: []
    },
    {
      role: "Software Engineer Intern",
      company: "Bending Spoons",
      companylogo: require("./assets/images/bending_spoons.png"),
      date: "July 2025 – October 2025",
      desc: "Worked on Streamyard in the AI Videography Platform time. Used TypeScript, Helm and Terraform to work on optimising and improving Kubernetes node management system. Read more about my time below",
      footerLink: [
        {
          name: "Read More",
          url: "https://www.linkedin.com/posts/ben-chapman-bjc_this-summer-i-had-the-amazing-opportunity-activity-7381013742106460161-l-5M?utm_source=share&utm_medium=member_desktop&rcm=ACoAAD62MDoBU6lk5zzNSOuOwZSrFd0UM-mhNrU"
        }
      ]
    },

    {
      role: "Software Engineer And AI Trainer",
      company: "DataAnnotation",
      companylogo: require("./assets/images/DataAnnotation-Tech_Logo_mini.webp"),
      date: "May 2024 – Dec 2024",
      desc: "Enhanced the performance of AI models through prompt categorization, response analysis, and iterative testing",
      footerLink: []
    }
  ]
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "University of Cambridge",
      logo: require("./assets/images/image.png"),
      subHeader: "BA (Hons) Computer Science",
      duration: "September 2024 - June 2027",
      desc: "First Year: First Class Honours",
      descBullets: ["1st Place - Cambridge Game Jam 2025"]
    },
    {
      schoolName: "St Albans School",
      logo: require("./assets/images/st_albans_school_logo.jpeg"),
      subHeader: "A Levels",
      duration: "September 2017 - June 2024",
      desc: "A* A* A* A* A*",
      descBullets: [
        "Mathematics - A*",
        "Further Mathematics - A*",
        "Computer Science - A*",
        "Economics - A*",
        "Extended Project Qualification (EPQ) in Ethics of Large Language Models - A*",
        "IGCSES - 10 x Grade 9"
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "false", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [],
  display: false // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Selected Achievements"),
  subtitle: "A Few things i've done recently",

  achievementsCards: [
    {
      title: "Jump Trading Datathon Cambridge 2025",
      subtitle:
        "Achieved 1st place in the individual competition and 2nd place in the team competition out of 40 participants selected to attend. Solved challenges relating to data transformation, cleanup and analysis.",
      image: require("./assets/images/jump_trading.png"),
      imageAlt: "Citadel Logo",
      footerLink: [
        {
          name: "More Info",
          url: "https://www.linkedin.com/posts/ben-chapman-bjc_1st-place-in-the-individual-and-2nd-place-activity-7383812147069210624-gEBg?utm_source=share&utm_medium=member_desktop&rcm=ACoAAD62MDoBU6lk5zzNSOuOwZSrFd0UM-mhNrU"
        }
      ]
    },
    {
      title: "Citadel Europe Terminal 2025",
      subtitle:
        "Placed 2nd winning £3500 in Citadel Europe Terminal 2025 of 40+ teams admitted to the competition from universities across Europe. Developed AI program to play tower-defense style game.",
      image: require("./assets/images/citadel.png"),
      imageAlt: "Citadel Logo",
      footerLink: [
        {
          name: "More Info",
          url: "https://www.linkedin.com/posts/ben-chapman-bjc_im-pleased-to-share-that-our-team-placed-activity-7321477289169326080-rcNm?utm_source=social_share_send&utm_medium=member_desktop_web&rcm=ACoAAD62MDoBU6lk5zzNSOuOwZSrFd0UM-mhNrU"
        }
      ]
    },
    {
      title: "Cambridge Game Jam 2025",
      subtitle:
        "Won 1st place in the Cambridge Game Jam 2025, developing a puzzle game in 48 hours with a team of 3.",
      image: require("./assets/images/gamejam.png"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "More Info",
          url: "https://www.linkedin.com/posts/ben-chapman-bjc_over-the-past-weekend-duy-huynh-thomas-activity-7294756193955184640-Vn3T?utm_source=social_share_send&utm_medium=member_desktop_web&rcm=ACoAAD62MDoBU6lk5zzNSOuOwZSrFd0UM-mhNrU"
        },
        {
          name: "Game Link",
          url: "https://squaresweets.itch.io/gusts-crusts"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    /*
    {
      url: ,
      title: 
      description:
        "","
    },
    {*/
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me"),
  subtitle: "",
  number: "",
  email_address: "ben.chapman.swe@gmail.com",
  display: false // Set false to hide this section, defaults to true
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  workExperiences,
  educationInfo,
  techStack,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
